module.exports = __webpack_public_path__ + "img/creditcards.8c695f6b.png";